module.exports = __webpack_public_path__ + "img/dwarf_18.04efc0fb.png";